import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import "../../style/contactPage/contactpage.scss"
import PhoneLogo from "../../assets/phoneLogo.svg"
import LocationLogo from "../../assets/locationLogo.svg"
import MailLogo from "../../assets/mailLogo.svg"
import { Container } from "react-bootstrap";
import {
  footer_contactNo,
  footer_address,
  footer_mail,
  contact_phone_text,
  contact_location_text,
  contact_Email_text,
} from "../../utility/constants";

function ContactDetails() {
  
  return (
    <div>
      <div className="background-container justify-content-end">
        <div className="px-0">
          <div className="justify-content-around  d-flex">
            <div className="logo-item">
              <img src={PhoneLogo} alt="Logo 1" className="logo-item-image" />
              <p>{contact_phone_text}</p>
              <h5>{footer_contactNo}</h5>
            </div>

            <div className="logo-item">
              <img src={LocationLogo} alt="Logo 2" className="logo-item-image" />
              <p>{contact_location_text}</p>
              <h5>{footer_address}</h5>
            </div>

            <div className="logo-item">
              <img src={MailLogo} alt="Logo 3" className="logo-item-image" />
              <p>{contact_Email_text}</p>
              <h5>{footer_mail}</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactDetails;
